var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraReleaseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4204_6592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.856 7.57798L8.36968 1.09167L7.74104 0.463501L0.626576 7.57798C0.394006 7.81118 0.394006 8.18871 0.626576 8.42144L5.08739 12.8821L7.74104 15.5364L14.856 8.42144C15.0887 8.18871 15.0887 7.81118 14.856 7.57798V7.57798ZM7.74104 10.2278L5.51309 8.00003L7.74104 5.77143L9.96947 8.00003L7.74104 10.2278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74105 5.77146C6.28242 4.3122 6.27497 1.94879 7.72553 0.480957L2.849 5.3556L5.50328 8.00988L7.74105 5.77146Z",
    fill: "url(#paint0_linear_4204_6592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9757 7.99377L7.74109 10.2279C8.4453 10.9315 8.84137 11.8865 8.84137 12.8822C8.84137 13.8779 8.4453 14.8323 7.74109 15.5365L12.6294 10.6481L9.9757 7.99377V7.99377Z",
    fill: "url(#paint1_linear_4204_6592)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4204_6592",
    x1: 6.78337,
    y1: 4.07754,
    x2: 4.23169,
    y2: 6.62858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4204_6592",
    x1: 8.72634,
    y1: 11.8976,
    x2: 11.2729,
    y2: 9.35107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4204_6592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraReleaseInactive);
export default __webpack_public_path__ + "static/media/jira-release-inactive.33277c9fcf6ce6d45794ab414ae493f3.svg";
export { ForwardRef as ReactComponent };